import {Dialog} from "@mui/material";
import {useState} from "react";
import Form from "../form/Form";
import {Controller, defaultLocationData} from "../form/controller";
import {FormContainer, FormDialogActionButtons, LoadingIcon} from "@dvrt/graphql-widgets";
import {useDispatch} from "react-redux";
import {showNotification} from "../../../actions";
import {defineMessage} from "react-intl";
import {Link} from "../../widgets";
import {DialogActions, DialogContent, FormattedDialogTitle} from "@dvrt/graphql-widgets";
import CreateAnotherCheckBox from "../../CreateAnotherCheckBox";
import {ContextFilters, useAuth} from "@/context/AuthProvider";
import {useDomainNameQuery} from "@/hooks";

export type Props = {
    domainId: number;
    onSuccess: () => void;
    close: () => void;
    show: boolean;
};

export default (props: Props) => {
    const {domainId, onSuccess, show} = props;

    const {domainName, loading: domainNameLoading} = useDomainNameQuery(domainId);

    const controller = new Controller(defaultLocationData, {domainId});
    const dispatch = useDispatch();
    const [createAnother, setCreateAnother] = useState(false);

    const auth = useAuth();
    const canEdit = auth.hasPermission("edit_location", ContextFilters.domain(domainName));

    if (domainNameLoading) return <LoadingIcon />;

    const close = () => {
        props.close();
        controller.reset();
    };

    async function submit() {
        const res = await controller.submit();

        if (!res.id) return;

        onSuccess();

        if (createAnother) controller.reset();
        else close();

        dispatch(
            showNotification(
                defineMessage({
                    id: "location.created",
                    defaultMessage: "Location {link} has been successfully created.",
                }),
                "success",
                {
                    link: <Link to={`/domains/${domainId}/locations/${res.id}/settings`}>{controller.data.name}</Link>,
                },
                10000,
            ),
        );
    }

    return (
        <Dialog open={show}>
            <FormattedDialogTitle title={defineMessage({id: "new_location", defaultMessage: "New location"})} />
            <DialogContent>
                <FormContainer>
                    <Form controller={controller} canEdit={canEdit} />
                </FormContainer>
            </DialogContent>
            <DialogActions>
                <CreateAnotherCheckBox state={createAnother} setState={setCreateAnother} />
                <FormDialogActionButtons
                    mainAction={submit}
                    secondaryAction={() => controller.reset()}
                    cancel={close}
                    enabled={controller.isChanged}
                />
            </DialogActions>
        </Dialog>
    );
};
